import {
  Alert,
  Box,
  Button,
  Chip,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { FilterBarProps } from './filter-bar.interface';
import { FilterKey, getFilters, IFilterOption } from './types';
import { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import SaveAsQuickFilterDialog from './save-as-quickfilter-dialog';
import { FilterOptionsChips } from './filter-chips';
import NewFeatureChip from '../new-feature-chip';
import { ElectricBolt, Speed } from '@mui/icons-material';
import { IconWithText } from '../styles/components';

function FilterBar({
  filterQueryAction,
  filterKeys,
  currentlySelectedFilters,
  headless,
  quickFiltersScope
}: FilterBarProps) {
  const { user, config } = useContext(AuthContext);
  const [filterOptions, setFilterOptions] = useState<IFilterOption[]>(
    currentlySelectedFilters
  );
  console.log('rerendered filterbar');
  const availableFilters = getFilters(filterKeys);
  const defaultKey = filterKeys[0];
  const [selectedFilterKey, setSelectedFilterKey] =
    useState<FilterKey>(defaultKey);
  const [openSaveAsQuickFilterDialog, setOpenSaveAsQuickFilterDialog] = useState(false);

  useEffect(() => {
    setFilterOptions(currentlySelectedFilters);
  }, [currentlySelectedFilters]);

  const filter = availableFilters.get(selectedFilterKey);

  if (!filter) {
    return <Alert severity="error">An error occurred.</Alert>;
  }
  console.log('outside useeffect filter options = ', filterOptions);

  useEffect(() => {
    console.log('filter options = ', filterOptions);
    console.log('hurray: ', JSON.stringify(filterOptions));
    filterQueryAction(filterOptions);
  }, [JSON.stringify(filterOptions)]);
  return (
    <Box
      component="fieldset"
      border={'none'}
      borderTop={'1px solid rgb(0,0,0,0.1)'}
    >
      {!headless && (
        <legend>
          <b>Filter Controls</b>
        </legend>
      )}

      <Box
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, marginBottom: 2 }}
      >
        <FilterOptionsChips filterOptions={filterOptions} setFilterOptions={setFilterOptions} />
      </Box>

      <Grid container spacing={1}>
        <Grid xs={12} md={2}>
          <Select
            fullWidth
            value={selectedFilterKey}
            onChange={(e) => {
              setSelectedFilterKey(e.target.value as FilterKey);
            }}
            autoWidth
            input={<OutlinedInput />}
            label={'filter by'}
          >
            {Array.from(availableFilters.keys()).map((item: string) => (
              <MenuItem value={item} key={item}>
                {' '}
                {item}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid xs={12} md={6}>
          {filter(filterOptions, setFilterOptions)}
        </Grid>
      </Grid>
      
      {
        quickFiltersScope && filterOptions.length > 0 && filterOptions.some((filter) => !filter.isQuickFilter()) && (
          <Button sx={{mt: 2}} onClick={() => {
            setOpenSaveAsQuickFilterDialog(true);
          }}
          size="small"
          variant="contained"
          >
            <IconWithText centered><ElectricBolt  /> Save as Quick Filter</IconWithText>
          </Button>
        )
      }
      {
        openSaveAsQuickFilterDialog && quickFiltersScope &&(
          <SaveAsQuickFilterDialog
            open={openSaveAsQuickFilterDialog}
            onClose={() => setOpenSaveAsQuickFilterDialog(false)}
            filterOptions={filterOptions}
            quickFiltersScope={quickFiltersScope}
            onSuccess={(filter) => {
              setOpenSaveAsQuickFilterDialog(false);
            }}
          />
        )
      }
    </Box>
  );
}

export default FilterBar;
